import React from 'react';
import { useAuth } from '@/lib/AuthContext';
import { Loader2, ShieldOff, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import AdminUserManager from '@/components/admin/AdminUserManager';

export default function AdminUsers() {
  const { user: currentUser, isLoadingAuth } = useAuth();

  if (isLoadingAuth) {
    return (
      <div className="min-h-screen bg-[#0d0d0f] pt-16 flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!currentUser || currentUser.role !== 'admin') {
    return (
      <div className="min-h-screen bg-[#0d0d0f] pt-16 flex items-center justify-center">
        <div className="text-center">
          <ShieldOff className="w-12 h-12 text-white/10 mx-auto mb-4" />
          <p className="text-white/40 text-sm font-bold tracking-widest">ACCESS DENIED</p>
          <p className="text-white/20 text-xs mt-2">You must be an admin to view this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0d0d0f] pt-16">
      {/* Header */}
      <section className="py-14 px-6 lg:px-10 border-b border-white/5">
        <div className="max-w-6xl mx-auto">
          <Link
            to="/admin/dashboard"
            className="inline-flex items-center gap-2 text-white/40 hover:text-white text-xs font-bold tracking-wider mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> BACK TO DASHBOARD
          </Link>
          <div>
            <p className="text-primary text-xs font-bold tracking-widest mb-2">SYSTEM &amp; INTEGRATIONS</p>
            <h1 className="text-white font-black text-2xl sm:text-3xl md:text-4xl uppercase">ADMIN USER MANAGEMENT</h1>
            <p className="text-white/30 text-sm mt-1">Create admins with a password, invite by email, edit existing admins and reset passwords.</p>
            <p className="text-white/30 text-xs mt-2">
              Logged in as: <span className="text-white font-medium">{currentUser.first_name || currentUser.full_name?.split(' ')[0]} ({currentUser.email})</span>
            </p>
          </div>
        </div>
      </section>

      <section className="px-6 lg:px-10 pt-10 pb-10 max-w-6xl mx-auto">
        <AdminUserManager currentUser={currentUser} />
      </section>
    </div>
  );
}